

export default ( pathname ) => {
    return pathname.match(/\/work\/(\w|-|.)*\//);
}